import { useEffect, useRef } from 'react';
import '../styles/LandingPage/PhasesHooks/SelectiveAdisory.css';

const services = [
  {
    icon: 'ti-file-check',
    title: 'IFRS 17 Technical Advisory',
    desc: 'End-to-end implementation support, measurement model selection, and transition methodology design for insurance contract accounting.',
    availability: 'Q3 2026',
    tag: 'High Demand',
  },
  {
    icon: 'ti-building-bank',
    title: 'Capital & Solvency Advisory',
    desc: 'Solvency II / SAM alignment, internal model development, and capital optimization strategies for insurers and reinsurers.',
    availability: 'Q3 2026',
    tag: 'Core Service',
  },
  {
    icon: 'ti-clipboard-check',
    title: 'Independent Model Validation',
    desc: 'Third-party validation of actuarial models, assumption governance frameworks, and model risk management protocols.',
    availability: 'Q4 2026',
    tag: 'New',
  },
  {
    icon: 'ti-chart-pie',
    title: 'Product & Profitability Analysis',
    desc: 'Product design review, embedded value analysis, and profitability attribution modelling for life and non-life portfolios.',
    availability: 'Q4 2026',
    tag: 'Strategic',
  },
  {
    icon: 'ti-file-upload',
    title: 'Regulatory Submission Support',
    desc: 'QRT preparation, supervisory dialogue support, and regulatory filing review for insurance undertakings.',
    availability: 'Q1 2027',
    tag: 'Compliance',
  },
];

const criteria = [
  { icon: 'ti-checks', text: 'Published peer-reviewed research in the domain' },
  { icon: 'ti-checks', text: 'Demonstrated model validation by external reviewers' },
  { icon: 'ti-checks', text: 'Clear intellectual property and methodology ownership' },
  { icon: 'ti-checks', text: 'Alignment with Actyra independence principles' },
];

export default function SelectiveAdvisory({ onClose }) {
  const modalRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    const handleClickOutside = (e) => {
      if (modalRef.current && !contentRef.current.contains(e.target)) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    modalRef.current?.addEventListener('click', handleClickOutside);

    requestAnimationFrame(() => {
      modalRef.current?.classList.add('is-open');
      contentRef.current?.classList.add('is-visible');
    });

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const handleClose = () => {
    modalRef.current?.classList.remove('is-open');
    contentRef.current?.classList.remove('is-visible');
    setTimeout(onClose, 400);
  };

  return (
    <div className="phase-modal-overlay advisory-overlay" ref={modalRef}>
      <div className="phase-modal advisory-modal" ref={contentRef}>
        
        <div className="modal-ambient">
          <div className="modal-orb orb-crimson" />
          <div className="modal-orb orb-rose" />
          <div className="modal-grid" />
        </div>

        <button className="modal-close" onClick={handleClose} aria-label="Close modal">
          <i className="ti ti-x" />
        </button>

        <div className="modal-header">
          <div className="modal-badge badge-upcoming">
            <span className="badge-ping" />
            Phase 2 — Upcoming
          </div>
          <h2>Selective Advisory</h2>
          <p className="modal-subtitle">
            High-value consulting engagements strictly limited to domains where 
            original Actyra research has been published and peer-tested.
          </p>
        </div>

        <div className="services-list">
          {services.map((service, i) => (
            <div className="service-row" key={service.title} style={{ '--si': i }}>
              <div className="service-row-glow" />
              <div className="service-icon-wrap">
                <i className={`ti ${service.icon}`} />
              </div>
              <div className="service-content">
                <div className="service-header">
                  <h4>{service.title}</h4>
                  <span className="service-tag">{service.tag}</span>
                </div>
                <p>{service.desc}</p>
                <div className="service-meta">
                  <span className="meta-availability">
                    <i className="ti ti-calendar" />
                    Available {service.availability}
                  </span>
                </div>
              </div>
              <div className="service-arrow">
                <i className="ti ti-chevron-right" />
              </div>
            </div>
          ))}
        </div>

        <div className="criteria-section">
          <h3>Engagement Criteria</h3>
          <p className="criteria-intro">
            Advisory is only offered where research credibility has been established. 
            Every engagement must satisfy all four principles:
          </p>
          <div className="criteria-grid">
            {criteria.map((c, i) => (
              <div className="criteria-item" key={i} style={{ '--ci': i }}>
                <i className={`ti ${c.icon}`} />
                <span>{c.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="modal-footer advisory-footer">
          <div className="footer-notice">
            <i className="ti ti-info-circle" />
            <span>Advisory slots are limited. Priority given to research collaborators.</span>
          </div>
          <button className="modal-cta cta-crimson" onClick={handleClose}>
            <span>Register Interest</span>
            <i className="ti ti-arrow-right" />
          </button>
        </div>
      </div>
    </div>
  );
}
